export default function ({ settings = {}, name, onChange, disabled }) {
  return [
    {
      type: "Switch",
      data: {
        value: Boolean(settings[name]),
        onChange,
        hidden: true,
      },
    },
  ];
}
